import { IconWrapper } from '../runtime';
export default IconWrapper('paste', false, function (h, props) {
  return h("svg", {
    "attrs": {
      "width": props.size,
      "height": props.size,
      "viewBox": "0 0 16 16",
      "fill": "none"
    }
  }, [h("path", {
    "attrs": {
      "d": "M11.25 11.9997C11.25 11.4474 11.6977 10.9997 12.25 10.9997H15.75L11.25 15.4997V11.9997Z",
      "fill": props.colors[0],
      "vector-effect": "non-scaling-stroke"
    }
  }), h("path", {
    "attrs": {
      "d": "M3.5 3.24973H3.25C2.42157 3.24973 1.75 3.9213 1.75 4.74973V11.7497C1.75 12.5782 2.42157 13.2497 3.25 13.2497H4.5M10 3.24973H10.25C11.0784 3.24973 11.75 3.9213 11.75 4.74973V5.99973M5 4.24973H8.5C9.19036 4.24973 9.75 3.69008 9.75 2.99973C9.75 2.30937 9.19036 1.74973 8.5 1.74973H5C4.30964 1.74973 3.75 2.30937 3.75 2.99973C3.75 3.69008 4.30964 4.24973 5 4.24973ZM11.5 14.7497H8C7.17157 14.7497 6.5 14.0782 6.5 13.2497V9.74973C6.5 8.9213 7.17157 8.24973 8 8.24973H13.5C14.3284 8.24973 15 8.9213 15 9.74973V11.2497L11.5 14.7497Z",
      "stroke": props.colors[0],
      "stroke-width": props.strokeWidth,
      "stroke-linejoin": props.strokeLinejoin,
      "vector-effect": "non-scaling-stroke"
    }
  })]);
});